<template>
    <div class="pl_wrapper">
        <div class="pl_closeBtn">
            <feather-icon icon="XIcon" @click="$router.back()"/>
        </div>
        <div class="pl_title">
            <h1>Carta de apresentação</h1>
        </div>
        <div class="pl_content">
            <vs-textarea 
                class="w-full no-icon-border my-1"
                v-model="payload.description"
                rows="23"
                type="text"
                label="Carta"
                placeholder="Exemplo: Possuo uma atitude empreendedora e sei como trabalhar em ambientes desafiadores com ritmo acelerado. Nos últimos dois anos, eu aumentei em 30% o faturamento de uma grande empresa do setor imobiliário, a partir dos meus estudos de viabilidade de projetos. O meu índice de acerto neste mesmo período foi de 96% e o resultado do meu trabalho evitou que diversos colaboradores fossem demitidos..."
            />
            <vs-button
                @click="submit()"
                class="w-full mt-5"
                color="primary"
                type="filled"
            >
                Salvar carta de apresentação
            </vs-button>
        </div>
    </div>
</template>

<script>
export default {
    data: () => ({
        payload: {
            description: ''
        }
    }),
    methods: {
        submit() {
            this.$vs.loading();

            const label = localStorage.getItem('label');

            this.$http.post(`api/v1/talent/${label}/user/professional-profile`, {
                ...this.payload
            }).then(() => {
                this.$vs.loading.close();
                this.$router.back();
            }).catch(() => {
                this.$vs.loading.close();
            })
        },
        fetchProfessionalDetail() {
            this.$vs.loading();

            const label = localStorage.getItem('label');

            this.$http.get(`api/v1/talent/${label}/user/talent`)
                .then(response => {
                    this.$vs.loading.close();
                    const {
                        talent,
                        professional_profile
                    } = response.data.data

                    this.payload = {
                        ...talent,
                        ...professional_profile,
                        regimes: (professional_profile.regimes ? professional_profile.regimes.split(',') : []),
                        remuneration: professional_profile.intended_remuneration,
                        available: (professional_profile.available === 'Não' || !professional_profile.available ? false : true ),
                        relocation: (professional_profile.relocation === 'Não' || !professional_profile.relocation ? false : true ),
                        remote: (professional_profile.remote === 'Não' || !professional_profile.remote ? false : true)
                    }
                })
                .catch(() => {
                    this.$vs.loading.close();
                })
        }

    },
    created() {
        this.fetchProfessionalDetail();
    }
}
</script>


<style lang="scss" scoped>
.pl_wrapper {
    min-height: 100vh;
    width: 100%;
    padding: 16px;
    background: #fff;

    @media screen and (min-width: 768px) {
        padding: 36px;
    }
}

.pl_closeBtn {
    display: flex;
    justify-content: flex-end;
}

.pl_title {
    display: flex;
    justify-content: center;

    h1 {
        font-size: 20px;
    }
}

.pl_content {
    padding: 16px 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

</style>